export default "__VITE_ASSET__DUXsxdGa__"